var exports = {
  "kL": "GuildTagTab.module__container___VUJES0",
  "Lv": "GuildTagTab.module__intro___VUJES0",
  "VH": "GuildTagTab.module__preview___VUJES0",
  "gz": "GuildTagTab.module__previewName___VUJES0",
  "qs": "GuildTagTab.module__previewEmpty___VUJES0",
  "bQ": "GuildTagTab.module__formBody___VUJES0",
  "yj": "GuildTagTab.module__help___VUJES0",
  "Nz": "GuildTagTab.module__picker___VUJES0",
  "X_": "GuildTagTab.module__pickerLabel___VUJES0",
  "O8": "GuildTagTab.module__iconGrid___VUJES0",
  "gb": "GuildTagTab.module__iconButton___VUJES0",
  "kp": "GuildTagTab.module__colorButton___VUJES0",
  "e5": "GuildTagTab.module__iconGlyph___VUJES0",
  "KW": "GuildTagTab.module__colorRow___VUJES0",
  "wH": "GuildTagTab.module__selected___VUJES0",
  "o1": "GuildTagTab.module__actions___VUJES0",
};

module.exports = exports;
